import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {Util} from "../../components/Util";
import {DateTime} from "../../components/ListComponent/DateTime";
import {ArrowDownSquareFill} from "react-bootstrap-icons";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {Dictionary} from "../../components/Dictionary";
import {TBody} from "../../components/Table/TBody";

export class ShipmentList extends ListComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return '/shipment/list';
    }

    protected navigate(event: any) {
        if (event.target.classList.contains('copy') || event.target.closest('a')) {
            return;
        }
        event.preventDefault();
        let id = event.target.closest('tr').getAttribute('data-id');
        super.navigate(event, '/shipment/details/' + id);
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const navigate = this.navigate,
            params: {} | any = this.getFormData();

        const searchBarClassList = window.location.hash ? 'search-bar' : 'search-bar hidden';
        const dictionary: Dictionary = this.dictionary;
        const statuses = this.state?.item?.statuses || [];

        return (
            <>
                <div className="row">
                    <h5 className="open-search">
                        {this.dictionary.get['search']}
                        <span onClick={this.toggleSearchBar} style={{
                            cursor: 'pointer',
                            fontWeight: 'normal',
                            paddingLeft: '20px',
                            fontSize: '13px'
                        }}><ArrowDownSquareFill/> {this.dictionary.get['detailed-search']}</span>
                    </h5>

                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className={searchBarClassList}>
                            <div className="row">

                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>
                                </div>

                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>
                                </div>

                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Select {...{
                                        id: 'status',
                                        basic: 'show-all',
                                        items: ['draft', 'import-error', 'unknown-product', 'open', 'create-error', 'in-transit', 'cancelled', 'sync-error', 'completed', 'close-error', 'closed', 'error'],
                                        defaultValue: params?.status
                                    }}/>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'created_from', defaultValue: params?.created_from}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'created_to', defaultValue: params?.created_to}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{
                                        id: 'imported_from',
                                        defaultValue: params?.imported_from
                                    }}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'imported_to', defaultValue: params?.imported_to}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'closed_from', defaultValue: params?.closed_from}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'closed_to', defaultValue: params?.closed_to}}/>
                                </div>
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'id:d'}/>

                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/shipment/export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['shipments']}: &nbsp;
                                    {this.state.count ? this.state.count : '-'} {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                        <div className="row" style={{marginBottom: '10px'}}>
                            {statuses.map(function (elem: any) {
                                return (
                                    <div className="col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2" key={TBody.index++}>
                                        {Util.searchStatus(elem.status, {
                                            style: {
                                                fontSize: '11px',
                                                fontWeight: 'normal'
                                            }
                                        })}
                                        &nbsp;<FormattedNumber value={elem.count}/>
                                        &nbsp;{dictionary.get['pc']}
                                    </div>);
                            })}
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="s.id">
                                    #ID<i className="bi bi-sort-down"></i>
                                </th>
                                <th className="sortable" data-sortkey="s.`reference_id`">
                                    RID
                                </th>
                                <th className="sortable" data-sortkey="s.`queue_id`">
                                    QID
                                </th>
                                <th className="sortable" data-sortkey="s.`fulfillment_id`">
                                    FID
                                </th>
                                <th className="sortable" data-sortkey="s.`status`">{this.dictionary.get['status']}</th>
                                <th className="sortable"
                                    data-sortkey="s.`item_count`">{this.dictionary.get['item_count']}</th>
                                <th className="sortable"
                                    data-sortkey="s.`product_count`">{this.dictionary.get['product_count']}</th>
                                <th className="sortable" data-sortkey="s.created_at">
                                    {this.dictionary.get['created_at']}
                                </th>
                                <th className="sortable" data-sortkey="s.imported_at">
                                    {this.dictionary.get['imported_at']}
                                </th>
                                <th className="sortable" data-sortkey="s.closed_at">
                                    {this.dictionary.get['closed_at']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                return (
                                    <tr key={elem.id} data-id={elem.id} onMouseDown={navigate}>
                                        <td className="copy" onClick={Util.copy} data-copy={elem.id}
                                            style={{textAlign: 'right'}}>{elem.id}.&nbsp;</td>
                                        <td className="copy" onClick={Util.copy}>{elem.reference_id}</td>
                                        <td className="copy" onClick={Util.copy}>{elem.queue_id}</td>
                                        <td className="copy" onClick={Util.copy}>{elem.fulfillment_id}</td>
                                        {Util.status(elem.status, {parentNode: 'td', style: {fontSize: '11px'}})}
                                        <td><FormattedNumber value={elem.item_count} suffix={dictionary.get['pc']}/></td>
                                        <td><FormattedNumber value={elem.product_count} suffix={dictionary.get['pc']}/></td>
                                        <td><DateTime value={elem.created_at}/></td>
                                        <td><DateTime value={elem.imported_at}/></td>
                                        <td><DateTime value={elem.closed_at}/></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={14}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
